import { region } from 'src/config'
import { EN_AU, EN_GB, EN_NZ, EN_US } from 'src/i18n/language-regions/constants'

/**
 * ISO 4217 codes for currencies we want to support. Note that when
 * submitting these to Stripe, Stripe may require these be lowercased.
 */
export const CURRENCIES = Object.freeze({
  AUD: 'AUD', // Australian Dollar
  AWG: 'AWG', // Aruban Guilder / Florin
  CAD: 'CAD', // Canadian Dollar
  EUR: 'EUR', // Euro
  GBP: 'GBP', // Pound Sterling
  GTQ: 'GTQ', // Guatemalan Quetzal
  GYD: 'GYD', // Guyanese Dollar
  NZD: 'NZD', // New Zealand Dollar
  PAB: 'PAB', // Panamanian Balboa
  TTD: 'TTD', // Trinidad and Tobago Dollar
  USD: 'USD', // US Dollar
  XCD: 'XCD', // Eastern Caribbean Dollar
  XCG: 'XCG' // Caribbean Guilder
})

function computeDefaultCurrencyForRegion (region) {
  switch (region) {
    case 'uk':
      return CURRENCIES.GBP
    case 'au':
      return CURRENCIES.AUD
    case 'nz':
      return CURRENCIES.NZD
    default:
      return CURRENCIES.USD
  }
}
export const DEFAULT_CURRENCY = computeDefaultCurrencyForRegion(region)

/**
 * DEPRECATED. This is currently kept because there is one place where an
 * Admin Report may need to decide on a locale without knowing the circuit's
 * locale, using only the report's currency. This is a temporary solution
 * until we update the report logic.
 */
export const CURRENCY_TO_LOCALE_MAP = Object.freeze({
  [CURRENCIES.USD]: EN_US,
  [CURRENCIES.GBP]: EN_GB,
  [CURRENCIES.AUD]: EN_AU,
  [CURRENCIES.NZD]: EN_NZ,
  [CURRENCIES.CAD]: EN_US, // Canada uses the same locale as the US
  // We don't have any cinemas strictly using the IE locale, but since
  // it's an English locale, it would fallback to an available English locale.
  [CURRENCIES.EUR]: 'en-IE' // though I think Ireland also accepts GBP ¯\_(ツ)_/¯
})
